import { OnlyLoggedOut } from 'components/auth/Redirects';
import A1ConnectLandingPageIntermediaireCampagne from 'components/landing-pages/a1connect-landing-page-intermediaire';
import { INSCRIPTION_LYCEEN_PATH } from 'lib/paths';

const pageConfig = {
  inscriptionPath: INSCRIPTION_LYCEEN_PATH,
  profile: 'lyceen',
  lpPath: 'a1connect-2',
  description: {
    header: 'Ton aventure INSPIRE commence ici',
    text: 'recommande aux lycéens des pistes d’études en fonction de leurs envies et de leurs notes.',
  },
};

const LyceenLandingPageIntermediaireCampagne = () => {
  return <A1ConnectLandingPageIntermediaireCampagne pageConfig={pageConfig} />;
};

LyceenLandingPageIntermediaireCampagne.getWrappers = (page) => (
  <OnlyLoggedOut>{page}</OnlyLoggedOut>
);

export default LyceenLandingPageIntermediaireCampagne;
